module.exports = __webpack_public_path__ + "media/images/ATAK_MIL-12e8268e02c742bb7b4e246ca2c38620.jpg";